"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var carDetailsStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        carDetailsWrapper: {
            fontFamily: typography.fontFamily2,
            color: palette.text.primary,
        },
        price: {
            fontWeight: 'initial',
        },
        carTitleImageContainer: {},
        modelTitle: {
            height: 0,
        },
    });
}, { name: 'Summary_CarDetails' });
exports.default = carDetailsStyles;
